import { SET_BROADCAST } from 'actions/Types';

function setBroadcast(broadcast) {
  return dispatch => {
    const action = {
      type: SET_BROADCAST,
      payload: broadcast
    };

    dispatch(action);
  };
}

export default setBroadcast;
